export default __webpack_public_path__ + "static/media/jewelry1.27db7d70.png";